@if (snapshot(); as snap) {
  <!-- z-index über dem Planungsassistenten: dessen Vollbild-Container liegt auf 1000 (common_styles) -->
  <dialog class="bm-modal z-[1200]" open (document:keydown.escape)="close()">
    <div class="bm-modal-box max-w-5xl w-full flex flex-col gap-4">
      <div class="flex flex-row items-start gap-2">
        <h3 class="bm-card-title flex-1">
          Debug-Infos zur Tourenberechnung
          <span class="bm-badge bm-badge-neutral bm-badge-xs">{{ snap.head.technician_name }} · {{ snap.head.day_date }}</span>
        </h3>
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="close()">
          <fa-icon [icon]="faTimes" />
        </button>
      </div>

      <div class="bm-alert bm-alert-soft" [class.bm-alert-error]="hasProblem()" [class.bm-alert-info]="!hasProblem()">
        <span class="whitespace-pre-line">{{ diagnosis() }}</span>
      </div>

      <div class="flex flex-row flex-wrap gap-2">
        <button class="bm-btn bm-btn-primary" (click)="copyToClipboard()">
          <fa-icon [icon]="copied() ? faCheck : faCopy" />
          {{ copied() ? "Kopiert" : "Alles kopieren" }}
        </button>
        <button class="bm-btn" (click)="downloadJson()">
          <fa-icon [icon]="faDownload" />
          Als Datei speichern
        </button>
        <span class="bm-label self-center">
          Kopierter Text enthält Bericht und Rohdaten — beides an die Entwicklung weitergeben.
        </span>
      </div>

      <div class="overflow-auto max-h-[60vh] border border-base-300 rounded bg-base-200">
        <pre class="text-xs p-3 whitespace-pre">{{ report() }}</pre>
      </div>
    </div>
    <form method="dialog" class="bm-modal-backdrop">
      <button (click)="close()">schließen</button>
    </form>
  </dialog>
}
